import { render, staticRenderFns } from "./EmpresaBanner.vue?vue&type=template&id=12794e05&scoped=true"
import script from "./EmpresaBanner.vue?vue&type=script&lang=js"
export * from "./EmpresaBanner.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBanner.vue?vue&type=style&index=0&id=12794e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12794e05",
  null
  
)

export default component.exports